// extracted by mini-css-extract-plugin
export default {"Comment":"styles_Comment__SMnmy","Comment__box":"styles_Comment__box__AhFDI","Comment__boxGreen":"styles_Comment__boxGreen__BHKAA","Comment__text":"styles_Comment__text__GPUJt"};